
import { getCondition } from "./ConditionAction";

const dispatchGetCondition = (dispatch: Function) => () => {
    dispatch(getCondition());
};

const ConditionDispatch = {
    dispatchGetCondition
};

export default ConditionDispatch